import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';

export default function RecipeSubmitted() {
  return (
    <MainLayout>
      <Head>
        <title>Receta enviada | Abasto Virtual</title>
        <meta name="robots" content="noindex" />
      </Head>
      <div className="mx-auto max-w-2xl px-4 py-12">
        <div className="rounded-lg border border-green-200 bg-green-50 p-8 text-center">
          <div className="mb-4 text-5xl text-green-600">
            <i className="fa fa-check-circle" />
          </div>
          <h1 className="mb-2 text-2xl font-bold text-gray-900">¡Gracias por tu receta!</h1>
          <p className="text-gray-700">
            Tu receta fue enviada correctamente y está pendiente de revisión. La vamos a revisar y publicar pronto.
          </p>
        </div>
      </div>
    </MainLayout>
  );
}
